import { render, staticRenderFns } from "./SalePricesAdditionalFeesSelection.vue?vue&type=template&id=ba574556&scoped=true"
import script from "./SalePricesAdditionalFeesSelection.vue?vue&type=script&lang=js"
export * from "./SalePricesAdditionalFeesSelection.vue?vue&type=script&lang=js"
import style0 from "./SalePricesAdditionalFeesSelection.vue?vue&type=style&index=0&id=ba574556&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba574556",
  null
  
)

export default component.exports